import { defineMessages } from 'react-intl';

export default defineMessages({
  rowsSelected: {
    id: 'rowsSelected',
    defaultMessage: '{count} row(s) selected'
  },
  deleteSelected: {
    id: 'deleteSelected',
    defaultMessage: 'Delete selected'
  },
  exportSelected: {
    id: 'exportSelected',
    defaultMessage: 'Export selected'
  },
  uploadFilesTitle: {
    id: 'uploadFilesTitle',
    defaultMessage: 'Upload file to list'
  },
  uploadFilesDescription: {
    id: 'uploadFilesDescription',
    defaultMessage: `Please select a file to upload. 
        File will be uploaded to the list {category} - {subcategory}.`
  }
});
